<template>
  <v-flex
    id="intangibleNeeds"
    class="question"
  >
    <p class="mb-0 text-uppercase">
      {{ $t('sheet.sheet_two.hint') }}
    </p>
    <h2 class="header mb-0">
      {{ getIntangibleNeedsQuestions.label }}
    </h2>
    <ul class="questions-list">
      <li
        v-if="getIntangibleNeedsQuestions.hasOwnProperty('has_intangible_needs')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getIntangibleNeedsQuestions.has_intangible_needs.required }"
        >
          {{ getIntangibleNeedsQuestions.has_intangible_needs.label }}
        </p>
        <ConfirmButtons
          v-model="hasIntangibleNeeds"
          v-validate="{ required: getIntangibleNeedsQuestions.has_intangible_needs.required }"
          string
          :error-messages="errors.collect('hasIntangibleNeeds')"
          :data-vv-as="' '"
          :data-vv-name="'hasIntangibleNeeds'"
          :disabled="readOnly"
        />
      </li>
      <li
        v-if="
          hasIntangibleNeeds === 'yes' &&
            getIntangibleNeedsQuestions.hasOwnProperty('intangible_needs_list')
        "
        class="mt-4"
      >
        <p
          class="header custom lA"
          :class="{ required: getIntangibleNeedsQuestions.intangible_needs_list.required }"
        >
          {{ getIntangibleNeedsQuestions.intangible_needs_list.label }}
        </p>
        <v-layout wrap>
          <v-flex
            v-for="(item, index) in intangibleNeedsList"
            :key="index"
            xs12
          >
            <v-layout align-center>
              <v-flex
                class="mt-4 mr-2"
                shrink
              >
                <span class="fw-600 f-2 text-dark">{{ indexNum(index) }}</span>
              </v-flex>
              <v-flex md5>
                <v-textarea
                  v-model="intangibleNeedsList[index]"
                  v-validate="{
                    ...requiredRegularField(
                      getIntangibleNeedsQuestions.intangible_needs_list.required
                    )
                  }"
                  :placeholder="$t('placeholders.add_text')"
                  :error-messages="errors.collect(createDataName('intangibleNeeds', index))"
                  :data-vv-as="' '"
                  :data-vv-name="createDataName('intangibleNeeds', index)"
                  :required="getIntangibleNeedsQuestions.intangible_needs_list.required"
                  :disabled="readOnly"
                  :rows="1"
                  auto-grow
                />
              </v-flex>
              <v-flex
                class="mt-2"
                shrink
              >
                <a
                  :disabled="!isCurrentEdition || readOnly"
                  @click="remove(index)"
                >
                  <BaseIcon class="clickable ml-2 mt-1">
                    <CartIcon :icon-color="$vuetify.theme.sz_grey" />
                  </BaseIcon>
                </a>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <a
              class="link_iconed"
              :disabled="!isCurrentEdition || readOnly"
              @click="add()"
            >
              <v-icon>add</v-icon> {{ $t('sheet.sheet_two.intangible_needs.add_btn') }}
            </a>
          </v-flex>
        </v-layout>
      </li>
    </ul>
    <v-divider class="my-4" />
  </v-flex>
</template>

<script>
import ConfirmButtons from '@/components/widgets/sheet/ConfirmButtons';
import CartIcon from '@/icons/CartIcon';
import BaseIcon from '@/icons/BaseIcon';

import validationRules from '@/constants/validationRules';
import { createHelpers } from 'vuex-map-fields';
import { mapGetters } from 'vuex';

import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';

const { mapFields } = createHelpers({
    getterType: 'sheet/getIntangibleNeedsFields',
    mutationType: 'sheet/updateIntangibleNeedsField'
});

export default {
    name: 'IntangibleNeeds',
    components: { ConfirmButtons, CartIcon, BaseIcon },
    mixins: [sheetValidationRules],
    inject: ['$validator'],
    props: {
        readOnly: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
            validationRules
        };
    },
    computed: {
        ...mapFields(['hasIntangibleNeeds', 'intangibleNeedsList']),
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        },
        ...mapGetters('sheet', ['getIntangibleNeedsQuestions'])
    },
    watch: {
        hasIntangibleNeeds: {
            handler (val) {
                if (val === 'yes' && this.intangibleNeedsList.length === 0) {
                    this.intangibleNeedsList.push(null);
                }
                if (val === 'no') {
                    this.$nextTick(() => {
                        this.intangibleNeedsList = [];
                    });
                }
            },
            immediate: true
        }
    },
    methods: {
        indexNum (index) {
            return index + 1 + '.';
        },
        createDataName (name, id) {
            return name + id;
        },
        add () {
            if (this.readOnly === true) {
                return;
            }
            this.intangibleNeedsList.push(null);
        },
        remove (index) {
            if (this.readOnly === true) {
                return;
            }
            if (this.intangibleNeedsList.length > 1) {
                this.intangibleNeedsList.splice(index, 1);
            }
        }
    }
};
</script>

<style scoped></style>
